import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { LoginEnums } from '../enums';
import { LoginAction } from '../store/auth.actions';
import { SetLoading } from 'src/app/shared/store/shared.actions';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BASE_URL } from 'src/environments/environment';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { emailValidator } from 'src/app/shared/validators/fields-validators';
import { FormFieldComponent } from 'src/app/shared/ui/form-field/form-field.component';
import { ButtonComponent } from 'src/app/shared/ui/button/button.component';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  imports: [ReactiveFormsModule, FormFieldComponent, ButtonComponent, RouterLink, TranslatePipe],
})
export class LoginPageComponent implements OnInit {
  fb = inject(FormBuilder);
  private route = inject(ActivatedRoute);
  private readonly store = inject<Store<AppState>>(Store);
  private readonly translateService = inject(TranslateService);

  loginEnums = LoginEnums;
  loginForm!: FormGroup;

  currentYear: number = new Date().getFullYear();
  currentLang: Observable<string> = this.store.select((state) => state.shared.currentLang);
  passwordVisible = false; // Initial state: password hidden
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  BASE_URL = BASE_URL;

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      database: [''],
      email: ['', Validators.compose([emailValidator(), Validators.required])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
    });
  }

  switchLanguage(lang: string) {
    if (lang !== this.translateService.getCurrentLang()) this.translateService.use(lang);
  }

  loginAction(): boolean {
    localStorage.clear();

    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return false;
    }

    const next = this.route.snapshot.queryParams['next'] || null;

    this.store.dispatch(SetLoading({ isAppLoading: true }));
    this.store.dispatch(LoginAction({ payload: this.loginForm.value, next }));

    return true;
  }
}
